import script from "./TagsPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./TagsPagination.vue?vue&type=script&setup=true&lang=js"

import "./TagsPagination.vue?vue&type=style&index=0&id=230bca80&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-230bca80"]])

export default __exports__